module.exports = __webpack_public_path__ + "static/img/hitbox-icon-box.a6203be0.jpg";